import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MetabolicReset() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-767">
      <article className="max-w-3xl mx-auto px-6" data-id="element-768">
        <AnimatedSection data-id="element-769">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-770">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-771" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-772">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-773">
              Nutrition
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-774">
              The Metabolic Reset: What Your Blood Work Reveals
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-775">
              Stop guessing. Your body already has answers — if you know how to
              read them.
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-776">
              <span data-id="element-777">Sep 28, 2025</span>
              <span className="mx-3" data-id="element-778">•</span>
              <span data-id="element-779">8 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-780">
          <p data-id="element-781">
            Most people try to fix their health blindly. But your body is
            already telling a story.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-782">
            Why Guessing Doesn't Work
          </h3>
          <p data-id="element-783">
            You can eat healthy, train consistently, and still not see results
            because you don't know what your body actually needs.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-784">
            What Blood Work Actually Shows
          </h3>
          <p data-id="element-785">
            Your labs reveal insulin sensitivity, inflammation, hormonal
            balance, nutrient deficiencies, and stress patterns.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-786">
            The Problem With Traditional Interpretation
          </h3>
          <p data-id="element-787">
            Most systems look for disease. We look for dysfunction before
            disease appears.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-788">
            What This Means for You
          </h3>
          <p data-id="element-789">
            If you feel off, tired, inflamed, or stuck, there is a reason — and
            it can be measured.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-790">
            The BioShift Perspective
          </h3>
          <p data-id="element-791">
            We connect labs, symptoms, and lifestyle to identify patterns and
            create real solutions.
          </p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-792">
            Stop guessing. Your body already has answers.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-793">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-794">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-795">
              Ready to stop guessing?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-796">
              Learn how our comprehensive metabolic assessments can provide the
              exact roadmap your body needs.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-797">
              Book a Free Health Strategy Call
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}